import { render, staticRenderFns } from "./Dialer.vue?vue&type=template&id=56132d9e&scoped=true&lang=pug"
import script from "./Dialer.vue?vue&type=script&lang=js"
export * from "./Dialer.vue?vue&type=script&lang=js"
import style0 from "./Dialer.vue?vue&type=style&index=0&id=56132d9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56132d9e",
  null
  
)

export default component.exports